import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../assets/css/PreTest.css";
import { baseurl } from "../utility/helper";
import HiddenPayuForm from "../components/forms/HiddenPayuForm";

const PreTest = () => {
  const Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const location = useLocation();
  const navigate = useNavigate();
  const { testId } = location.state || {};
  const [testData, setTestData] = useState(null);
  const [error, setError] = useState(null);
  const [fees, setFees] = useState(null);
  const [formData, setFormData] = useState({
    education: "",
  });

  useEffect(() => {
    fetchFees();
  }, []);

  const fetchFees = async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/getFees`);
      const feeRecord = response.data.find(fee => fee.fee_id === 2 || fee.fee_id === '2');

      if (feeRecord) {
        console.log("Fee Amount:", feeRecord.fees);
        setFees(feeRecord.fees);
        // Use feeRecord.fees as needed
      } else {
        console.warn("Fee with ID 4 not found");
      }
    } catch (error) {
      console.error("Error fetching fees:", error);
      alert("Failed to fetch fees.");
    }
  };


  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
  const radiohandleChange = (e) => {
    const { name, value } = e.target; // Use name instead of id
    setFormData({ ...formData, [name]: value }); // Update the formData using name
  };


   return (
    <div>
      <div className="preevent">
        <div className="container" style={{ paddingTop: "30px" }}>
          <div className="row">
            <div className="pretestregister col-lg-8">
              <h1
                style={{ fontSize: "30px", fontWeight: "bold", color: "grey" }}
              >
                Mensa India Pre-test
              </h1>
              <br />
              <p>Thank you for your interest in the Mensa India Pre-test.</p>
              <p style={{ fontWeight: "400" }}>
                This Pre-test is a fun and trouble free way to check if you are
                Mensa material , in the privacy of your home.
              </p>
              <p>
                While this 40 minute pre-test will not qualify you for
                membership to Mensa, it does offer a score range that correlates
                to your IQ and provides a strong indication of your likelihood
                for success should you choose to take our official Mensa India
                admission test.
              </p>
              <p>
                The cost of the test is Rs 550. "If you want to take the test please click on 'Apply Now' button"
              </p>

              {Candidateid !== null && (
                <div className="row">
                  <HiddenPayuForm testId={`PreTest`}/>
                </div>
              )}
            </div>

            {Candidateid === null ? (
              <div className="col-lg-4">
                <div style={{ padding: "15px", textAlign: "center" }}>
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate("/Candidatelogin", { state: { fromPage: "PreTest" } })}
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            ) : (
             ""
            )}
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default PreTest;